// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service from "../../../../proto/taxapis/gen/buhta_tax_control_v1alpha1_chief_information_service.js";
import * as Buhta_taxapis__Buhta_tax_control_v1alpha1_person_category_benefit from "../../../../proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.js";
import * as Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service from "../../../../proto/taxapis/gen/buhta_tax_control_v1alpha1_tax_information_service.js";
import * as Curry from "melange.js/curry.js";

const PersonCategory = {};

const make = Buhta_taxapis__Buhta_tax_control_v1alpha1_person_category_benefit.Buhta.Tax.Control.V1alpha1.PersonCategoryBenefit.make;

const PersonCategoryBenefit = {
  make: make
};

const PersonStatus = {};

const TaxInformation = {};

const TaxDeductionType = {};

const ChiefInformation = {};

function toUpdateRequest(info) {
  return Curry._3(Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service.Buhta.Tax.Control.V1alpha1.UpdateChiefInformationRequest.make, info, undefined, undefined);
}

const ChiefInformationForm = {
  toUpdateRequest: toUpdateRequest
};

function toUpdateRequest$1(info) {
  return Curry._3(Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service.Buhta.Tax.Control.V1alpha1.UpdateTaxInformationRequest.make, info, undefined, undefined);
}

const TaxInformationForm = {
  toUpdateRequest: toUpdateRequest$1
};

const apiEndpointPrefix = "/tax";

function view(tenant, expandOpt, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._2(Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service.Buhta.Tax.Control.V1alpha1.GetChiefInformationRequest.make, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.info);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service.Buhta.Tax.Control.V1alpha1.ChiefInformationService.getChiefInformation, undefined, tenant, undefined, apiEndpointPrefix + Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service.Buhta.Tax.Control.V1alpha1.ChiefInformationService.GetChiefInformation.name, undefined, undefined));
}

function update(tenant, info) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.info);
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest(info), Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service.Buhta.Tax.Control.V1alpha1.ChiefInformationService.updateChiefInformation, undefined, tenant, undefined, apiEndpointPrefix + Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information_service.Buhta.Tax.Control.V1alpha1.ChiefInformationService.UpdateChiefInformation.name, undefined, undefined));
}

const ChiefInformationService = {
  view: view,
  update: update
};

function view$1(tenant, expandOpt, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._2(Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service.Buhta.Tax.Control.V1alpha1.GetTaxInformationRequest.make, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.info);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service.Buhta.Tax.Control.V1alpha1.TaxInformationService.getTaxInformation, undefined, tenant, undefined, apiEndpointPrefix + Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service.Buhta.Tax.Control.V1alpha1.TaxInformationService.GetTaxInformation.name, undefined, undefined));
}

function update$1(tenant, info) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.info);
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest$1(info), Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service.Buhta.Tax.Control.V1alpha1.TaxInformationService.updateTaxInformation, undefined, tenant, undefined, apiEndpointPrefix + Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_information_service.Buhta.Tax.Control.V1alpha1.TaxInformationService.UpdateTaxInformation.name, undefined, undefined));
}

const TaxInformationService = {
  view: view$1,
  update: update$1
};

export {
  PersonCategory ,
  PersonCategoryBenefit ,
  PersonStatus ,
  ChiefInformation ,
  TaxInformation ,
  TaxDeductionType ,
  ChiefInformationForm ,
  TaxInformationForm ,
  ChiefInformationService ,
  TaxInformationService ,
}
/* Buhta_core__Grpc Not a pure module */
